const rawCookie = (name: string): string | null => {
  const prefix = `${name}=`;
  const part = document.cookie.split(';').map(v => v.trim()).find(v => v.startsWith(prefix));
  return part ? part.slice(prefix.length) : null;
};

export function getOpenAIAttribution(): { oppref: string | null; obref: string | null } {
  if (typeof window === 'undefined') return { oppref: null, obref: null };
  const query = new URLSearchParams(window.location.search);
  return {
    oppref: query.get('oppref') || query.get('__oppref') || rawCookie('__oppref'),
    obref: query.get('obref') || query.get('__obref') || rawCookie('__obref'),
  };
}

export function sourceUrl(): string {
  return `${window.location.origin}${window.location.pathname}`;
}
